<template>
  <div @click="$emit('click')" class="promo_card">
    <div :style="{ backgroundColor: imgBgrColor }" class="promo_card_photo">
      <div class="promo_card_photo__inner">
        <img :src="img" v-if="img" alt="">
      </div>

      <!--			<template v-else>
				<img :src="img" alt="" v-if="img">
			</template>-->
    </div>
    <div class="promo_card_title">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: '',
    },
    title: String,
    imgBgrColor: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="less">
.promo {
	&_card {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		margin-bottom: 40px;
		cursor: pointer;

		&_photo {
			width: 100%;
			//height: 250px;
			background-color: #F6F6F6;
			background-image: url('/ad.svg');
			background-size: auto;
			background-position: center;
			background-repeat: no-repeat;
			border-radius: 30px;
			overflow: hidden;
			margin-bottom: 20px;

			&__inner {
				margin: 0 30px;
				display: flex;
				justify-content: center;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center;
				display: block;
			}
		}

		&_title {
			p {
				font-family: 'Aqum', Arial, sans-serif;
				font-weight: 500;
				font-size: 14px;
			}
		}
	}
}
</style>
